export default __webpack_public_path__ + "static/media/file-jpg.fd440c65.svg";